export interface TagModel {
  id: number;
  name: string;
}

export interface TagEditorModel {
  id: number;
  objectType: TagEditorEntity;
  tags: any;
}

export enum TagEditorEntity {
  RESPONSE = 'response',
}

export interface ResponseTag {
  name: string;
  value: string;
}

export interface DeleteTagRequest {
  tagId: number;
  objectId: number;
}

export interface CreateTagsRequest {
  objectType: TagEditorEntity;
  objectIds: number[];
  tags: { name: string; value: null }[];
}

export interface Tag {
  id: string;
  text: string;
}

export interface TagEditorStateModel {
  visible: boolean;
  id: number;
  objectType?: TagEditorEntity | null;
  tags: Tag[];
  tagRepository: TagRepository;
}

export interface TagRepository {
  [key: string]: {
    [key: number]: any;
  };
}

export interface TagRepositoryRecord {
  [key: number]: any[];
}

export interface TagRepositoryUpdatePayload {
  repository: string;
  ids: number[];
  tags: any;
}

export interface TagRepositoryRegisterPayload {
  repository: string;
  records: any;
}

export interface Tags {
  [key: string]: string;
}

export interface TagObject {
  type: string;
  value: string;
  tooltip: string;
}

export interface TagTooltip {
  [key: string]: string;
}
